import { createSlice } from '@reduxjs/toolkit'

export const loadingSlice = createSlice({
    name: 'loading',
    initialState: {
        loading: false
    },
    reducers: {
        setLoadingGif(state, action) {
            state.loading = action.payload;
        },
    },
})

export const { setLoadingGif } = loadingSlice.actions;

export default loadingSlice.reducer

